export function setToken(go){
  // console.log(go)
  // let locale = sessionStorage.getItem('language')||'zh';
  // let temp = locale === 'zh' ? 's' : 't';
  // return temp
}
export function getToken(){
  let locale = sessionStorage.getItem('language')||'';
  // let temp = locale === 'zh' ? 's' : 't';
  return locale
}
export default{
  setToken,
  getToken
}